module.exports = __webpack_public_path__ + "static/img/200098.ee7207db.png";